import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { Col, Grid, Row, styled, up, css, thd } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import { withSettings } from '../../containers/WebApp/SettingsContext';
import PrivateComponent from '_platform/src/utils/PrivateComponent';
import IconWrapper from '_platform/src/components/SvgIcon/IconWrapper';
import Banner from 'components/CustomComponents/Banners/Banner';
import BgPrimary from 'components/CustomComponents/Backgrounds/BgPrimary';
import BgSecondary from 'components/CustomComponents/Backgrounds/BgSecondary';

// import Appliances1x from './images/Appliances-Banner.jpg';
// import Appliances2x from './images/Appliances-Banner@2x.jpg';

//import EasterBanner1x from './images/EatserBannerV3@1x.png';
//import EasterBanner2x from './images/EatserBannerV4@2x.png';
//import MobileEasterBanner1x from './images/Mobile-EatserBanner@1x.png';
// import MobileEasterBanner2x from './images/Mobile-EatserBanner-v2@2x.png';

import bannerImg from './images/banner-hot-deals-desktop.jpg';
import bannerImgMobile from './images/banner-hot-deals-mobile.jpg';
import bannerImgTablet from './images/banner-hot-deals-tablet.jpg';

import Points from './images/icon-points.svg';
import Account from './images/icon-account.svg';
import Wishlist from './images/icon-wishlist.svg';

import DiscoverReward from './images/bg-discover-rewards.png';

// import Shop from './images/shop-@2x.jpg';

const TwoColumnContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 10px;
  flex-direction: column;
  ${up(
    'md',
    css`
      padding: 80px 0;
      flex-direction: row;
    `
  )}

  & > div:first-child {
    padding-right: 0;
    flex-basis: 40%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    ${up(
      'md',
      css`
        padding-right: 2rem;
        padding-bottom: 0;
      `
    )}

    h2 {
      line-height: 1;
    }
  }

  & > div:last-child {
    border-top: 1px solid white;
    padding-top: 20px;

    ${up(
      'md',
      css`
        padding-top: 0;
      `
    )}

    p:last-child {
      margin-bottom: 0;
    }

    ${up(
      'md',
      css`
        padding-left: 4rem;
        border-top: none;
        border-left: 1px solid white;
      `
    )}
  }
`;

const Panel2 = styled.div`
  padding: 20px 0 0 0;
  box-shadow: 0px 10px 40px #00000029;
  text-align: center;
  background: #fcfcfc 0% 0% no-repeat padding-box;

  &:hover,
  &:focus,
  &:active {
    background: #cd1723 0% 0% no-repeat padding-box;
  }

  svg {
    width: 100%;
    height: 100%;
    max-width: 132px;
    max-height: 132px;
  }

  a {
    width: 100%;
    max-width: 230px;
    height: 300px;
    text-decoration: none;
    stroke: #cd1723;
    fill: #cd1723;

    &:hover {
      color: #fff;
      stroke: #fff;
      fill: #fff;

      svg {
        &:hover {
          stroke: #fff;
        }
      }
    }
  }
`;

/*const ShopNow = styled.button`
  background: #cd1723;
  color: #fff;
  font-size: 80px;
  font-weight: bold;
  border: 0;
  width: 100%;
  height: 100%;
  margin: 0;
`;*/

const Panels = styled.div`
  padding: 20px 0 0 0;
  box-shadow: 0px 10px 40px #00000029;
  text-align: center;
  background: #fcfcfc 0% 0% no-repeat padding-box;

  &:hover,
  &:focus,
  &:active {
    background: #cd1723 0% 0% no-repeat padding-box;
  }

  svg {
    width: 100%;
    height: 100%;
    max-width: 132px;
    max-height: 120px;
  }

  a {
    width: 100%;
    max-width: 230px;
    height: 300px;
    text-decoration: none;
    fill: #cd1723;

    &:hover,
    &:focus,
    &:active {
      color: #fff;
      fill: #fff;

      svg {
        &:hover,
        &:focus,
        &:active {
          fill: #fff;
        }
      }
    }
  }
`;

const Dashboard = styled(Grid)`
  h2 {
    margin-bottom: 0;
  }

  a {
    text-decoration: none;
    margin-bottom: 40px;
    display: block;

    img {
      max-width: 150px;
    }

    span {
      display: block;
      width: 205px;
      max-width: 100%;
      padding: 5px;
      margin: 0 auto;
      background-color: white;
      color: ${thd('primary', '#cd1723')};
      text-align: center;
      border: 1px white solid;
    }

    &:hover,
    &:focus {
      span {
        color: white;
        background-color: ${thd('primary', '#cd1723')};
      }
    }
  }
`;

const DiscoverRewards = styled.div`
  background-image: url(${DiscoverReward});
  background-position: center;
  background-size: cover;
  ${up(
    'md',
    css`
      min-height: 400px;
      background-opacity: 0.5;
    `
  )}

  & > div {
    background: rgba(239, 239, 239, 0.5);
    ${up(
      'md',
      css`
        background: none;
      `
    )}
  }
`;

const HomePage = ({ settings }) => {
  return (
    <div className="page-container">
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent
        redirectOnError={{
          pathname: settings.settingsApp.loginPagePath || '/login/',
        }}
      >
        <Link to="/shop">
          <Banner
            pageTitle=""
            bannerMobile={bannerImgMobile}
            bannerMobile2x={bannerImgMobile}
            bannerTablet={bannerImgTablet}
            bannerTablet2x={bannerImgTablet}
            bannerDesktop={bannerImg}
            bannerDesktop2x={bannerImg}
          />
          <span className="sr-only">
            Red hot deals. Limited time only. Until the 22nd April Only.
            Panasonic 65" TV TN-65W70AGZ 999 RSR Points. Save over 1000 points.
            Espresso Machine with build in grinder BES870BSS. 499 RSR points.
            Save over 300 points. Items will need to be collected from local
            branch.
          </span>
        </Link>
        <BgSecondary>
          <Grid>
            <TwoColumnContainer>
              <div>
                <h2 className="h1 text--tight text--center">
                  Hard work has it's Rewards
                </h2>
              </div>
              <div>
                <h2 className="text--tight text--center">
                  Reward Yourself. You’ve earned it.
                </h2>
                <p className="text--center">
                  Enjoy the benefits of your hard work with rewards just for
                  you. Every point you’ve earned brings you closer to something
                  special - whether it’s a great product, an experience to
                  remember, or a personalised Visa card. Explore your options
                  and treat yourself.
                </p>
              </div>
            </TwoColumnContainer>
          </Grid>
        </BgSecondary>
        <Grid>
          <Row justifyContent="center" className="spacer">
            <Col xs={12} md={3}>
              <Panel2>
                <a href="/shop">
                  <IconWrapper>
                    <svg
                      data-name="Group 135"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 127.5 131.9"
                    >
                      <defs>
                        <clipPath id="a">
                          <path
                            data-name="Rectangle 123"
                            fill="none"
                            strokeWidth="6"
                            d="M0 0h127.5v131.9H0z"
                          />
                        </clipPath>
                      </defs>
                      <g
                        data-name="Group 134"
                        clipPath="url(#a)"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="6"
                      >
                        <path
                          data-name="Path_124"
                          d="M52.2 83.3h56.5a7 7 0 0 0 6.9-5.6l8.3-38.7a7.7 7.7 0 0 0-7.4-9.4H34.2"
                        />
                        <path
                          data-name="Path_125"
                          d="m10.5 10.5 14.2 1a5 5 0 0 1 4.4 3.7l18.7 68.1"
                        />
                        <path
                          data-name="Path_127"
                          d="M115 100.6H50.6A8.7 8.7 0 0 1 42 92h0a8.7 8.7 0 0 1 8.6-8.7h15.5"
                        />
                        <path
                          data-name="Path_128"
                          d="M111.7 120.7a7.7 7.7 0 1 1-7.7-7.7 7.7 7.7 0 0 1 7.7 7.7"
                        />
                        <path
                          data-name="Path_129"
                          d="M61.1 120.7a7.7 7.7 0 1 1-7.7-7.7 7.7 7.7 0 0 1 7.7 7.7"
                        />
                        <path data-name="Line_8" d="M63.2 69.1 58.7 45" />
                        <path data-name="Line_9" d="m81.3 68.7-.8-24.3" />
                        <path data-name="Line_10" d="m99.6 69.1 3-24.1" />
                      </g>
                    </svg>
                  </IconWrapper>
                  <h4>Shop</h4>
                  <p className="spacer--bottom">Learn More</p>
                </a>
              </Panel2>
            </Col>

            <Col xs={12} md={3} className="text-center">
              <Panels>
                <a href="/anythings-possible">
                  <IconWrapper>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="119"
                      height="120.145"
                      viewBox="0 0 119 120.145"
                    >
                      <defs>
                        <clipPath id="clip-path">
                          <rect
                            id="Rectangle_121"
                            data-name="Rectangle 121"
                            width="119"
                            height="120.145"
                            transform="translate(0 0)"
                          />
                        </clipPath>
                      </defs>
                      <g
                        id="Group_131"
                        data-name="Group 131"
                        transform="translate(0 -0.003)"
                      >
                        <g
                          id="Group_130"
                          data-name="Group 130"
                          transform="translate(0 0.003)"
                          clipPath="url(#clip-path)"
                        >
                          <path
                            id="Path_118"
                            data-name="Path_118"
                            d="M101.58,17.605a59.1,59.1,0,0,0-84.161,0,60.483,60.483,0,0,0,0,84.94,59.1,59.1,0,0,0,84.161,0,60.482,60.482,0,0,0,0-84.94M93.163,58a96.938,96.938,0,0,0-4.017-26.391,96.483,96.483,0,0,0,14.27-5.277A55.811,55.811,0,0,1,114.633,58Zm-4.317,0H61.558V35.643a109.974,109.974,0,0,0,23.4-2.949A92.492,92.492,0,0,1,88.846,58M61.558,31.318V4.95a16.536,16.536,0,0,1,3.419.857,23.9,23.9,0,0,1,9.2,6.567,50.463,50.463,0,0,1,9.385,16.21,105.716,105.716,0,0,1-22,2.735M48.324,8.839a20.744,20.744,0,0,1,5.384-3.032,16.488,16.488,0,0,1,3.525-.872V31.321a105.766,105.766,0,0,1-22.11-2.731,60.931,60.931,0,0,1,3.708-8.128A37.061,37.061,0,0,1,48.324,8.839m8.909,26.807V58H29.847A92.5,92.5,0,0,1,33.729,32.7a110.021,110.021,0,0,0,23.5,2.942M25.513,58H4.367A55.812,55.812,0,0,1,15.493,26.449a96.549,96.549,0,0,0,14.041,5.17A96.916,96.916,0,0,0,25.513,58m.015,4.325a97.174,97.174,0,0,0,3.823,25.419,96.361,96.361,0,0,0-14.322,5.332A55.81,55.81,0,0,1,4.374,62.322Zm4.321,0H57.233V83.661a109.978,109.978,0,0,0-23.694,2.987,92.751,92.751,0,0,1-3.69-24.326M57.233,87.986v27.04a16.493,16.493,0,0,1-3.525-.872,23.9,23.9,0,0,1-9.2-6.567A50.992,50.992,0,0,1,34.9,90.769a105.7,105.7,0,0,1,22.333-2.782m13.128,23.136a20.733,20.733,0,0,1-5.384,3.032,16.552,16.552,0,0,1-3.419.857V87.988a105.667,105.667,0,0,1,22.218,2.789A61.589,61.589,0,0,1,79.855,99.5a37.061,37.061,0,0,1-9.494,11.623m-8.8-27.46V62.322H88.834a92.767,92.767,0,0,1-3.688,24.335,109.911,109.911,0,0,0-23.587-2.994m31.6-21.341h21.464A55.814,55.814,0,0,1,103.881,93.2a96.136,96.136,0,0,0-14.548-5.449,97.157,97.157,0,0,0,3.83-25.427m7.42-39.454A92.62,92.62,0,0,1,87.766,27.5a66.293,66.293,0,0,0-4.125-9.128A42.574,42.574,0,0,0,74.084,6.3,55,55,0,0,1,98.507,20.648q1.069,1.08,2.076,2.219M44.449,6.427a34.5,34.5,0,0,0-3.137,3.037,55.014,55.014,0,0,0-10.4,18.046,92.772,92.772,0,0,1-12.595-4.528q1.057-1.2,2.177-2.335A55.013,55.013,0,0,1,44.449,6.427M17.783,96.562A92.429,92.429,0,0,1,30.7,91.855a66.872,66.872,0,0,0,4.34,9.736,42.335,42.335,0,0,0,9.747,12.226A55,55,0,0,1,20.493,99.5q-1.406-1.421-2.71-2.941M73.76,113.94a34.066,34.066,0,0,0,3.613-3.443A55.516,55.516,0,0,0,87.985,91.863a92.3,92.3,0,0,1,13.131,4.814q-1.257,1.457-2.609,2.826A54.988,54.988,0,0,1,73.76,113.94"
                            transform="translate(0 -0.003)"
                          />
                        </g>
                      </g>
                    </svg>
                  </IconWrapper>
                  <h4>Anything's Possible</h4>
                  <p className="spacer--bottom">Learn More</p>
                </a>
              </Panels>
            </Col>

            <Col xs={12} md={3}>
              <Panels>
                <a href="/shop/category/single-load-visa-cards">
                  <IconWrapper>
                    <svg
                      data-name="Group 133"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 122 116.9"
                    >
                      <defs>
                        <clipPath id="a">
                          <path
                            data-name="Rectangle 122"
                            d="M0 0h122v116.9H0z"
                          />
                        </clipPath>
                      </defs>
                      <g data-name="Group 132" clipPath="url(#a)">
                        <path
                          data-name="Path_119"
                          d="m122 49.2-.2-1.2-.5-2.2-7.4-21.3v-.1l-4.4-12.5v-.1l-1.1-3a13 13 0 0 0-16.7-8l-66 23a13 13 0 0 0-8.1 16.6l1 3 2 5.5a1.8 1.8 0 0 0 3.4-1.2L22.7 44l84-29.2 3.1 9.2-64.6 22.5a1.8 1.8 0 0 0 .6 3.6l.6-.1 64.7-22.6 6.8 19.6.4 1.6.1.9a9.5 9.5 0 0 1-6.3 9.5l-12.6 4.8a1.8 1.8 0 0 0 .7 3.5l.6-.1 12.5-4.7a13 13 0 0 0 8.8-13.3M21.5 40.5l-.5-1.3a9.5 9.5 0 0 1 5.9-12l66-23a9.5 9.5 0 0 1 12 5.8l.5 1.3Z"
                        />
                        <path
                          data-name="Path_120"
                          d="M83 116.9H13.2a13 13 0 0 1-13.1-13V64.7a13 13 0 0 1 13-13.2h70a13 13 0 0 1 13 13.2v39.1a13 13 0 0 1-13 13.1m-70-61.7a9.5 9.5 0 0 0-9.4 9.5v39.1a9.5 9.5 0 0 0 9.4 9.5h70a9.5 9.5 0 0 0 9.4-9.5V64.7a9.5 9.5 0 0 0-9.4-9.5Z"
                        />
                        <path
                          data-name="Path_121"
                          d="M79.5 80.8h-15a6.5 6.5 0 0 1-6.6-6.5v-5.4a6.5 6.5 0 0 1 6.5-6.5h15.1a6.5 6.5 0 0 1 6.5 6.5v5.4a6.5 6.5 0 0 1-6.5 6.5M64.5 66a3 3 0 0 0-3 2.9v5.4a3 3 0 0 0 3 2.8h15a3 3 0 0 0 2.9-2.8v-5.4a3 3 0 0 0-2.9-2.9Z"
                        />
                        <path
                          data-name="Path_122"
                          d="M83.9 95.8H11.1a1.8 1.8 0 0 1 0-3.6h72.8a1.8 1.8 0 0 1 0 3.6"
                        />
                        <path
                          data-name="Path_123"
                          d="M43.1 104.3h-32a1.8 1.8 0 1 1 0-3.6h32a1.8 1.8 0 1 1 0 3.6"
                        />
                      </g>
                    </svg>
                  </IconWrapper>
                  <h4>RSR Visa Cards</h4>
                  <p className="spacer--bottom">Learn More</p>
                </a>
              </Panels>
            </Col>
            <Col xs={12} md={3}>
              <Panel2>
                <a href="/visa-reload">
                  <IconWrapper>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 118.2 107.3"
                    >
                      <g data-name="Group 137" transform="translate(.7 .7)">
                        <g>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 322.98 102.62"
                            width="60"
                            x="47"
                            y="12"
                          >
                            <g data-name="RSR Logo">
                              <path
                                d="M75.32 102.5c-4.57-6.1-5.55-7.3-8-10.38q44.16 0 88.3-.06a107 107 0 0 0 15.42-1.27 19 19 0 0 0 12.17-6.5c4.58-5.47 2.18-10.5-3.94-12.37a30 30 0 0 0-7.72-1.08c-5.64-.18-11.28-.07-16.91-.15-6.05-.08-12.1-.2-18.06-1.5a26.5 26.5 0 0 1-11.1-4.82 13.5 13.5 0 0 1-4.52-15.6c2.3-6.6 6.9-11.08 12.96-14.2a52 52 0 0 1 23.62-5.37c22.91-.22 45.83-.1 68.75-.1h15.82l-.34 10.9-19.75.03q-29.37-.06-58.73.03c-4.56.01-9.07.42-13.14 2.85a16 16 0 0 0-6.15 5.87 6.6 6.6 0 0 0 2.57 9.3 16 16 0 0 0 7.8 2.03c6.32.2 12.63.2 18.94.37 4.48.13 8.98.18 13.44.64 5.3.56 10.46 1.74 15.08 4.73a13.76 13.76 0 0 1 5.83 16.1c-2.17 6.86-6.85 11.47-13.08 14.64-8.16 4.15-17 5.37-25.96 5.5-23.02.33-85.23.39-93.31.39"
                                data-name="Path_142"
                              />
                              <path
                                fill="#313232"
                                d="M26.32 13.92h7l-.06.56h-7.6L27.44.01h.6Z"
                                data-name="Path_143"
                              />
                              <g fill="#313232" data-name="Group 76">
                                <path
                                  d="M41.66 14.06c3.03 0 3.63-1.97 3.92-4.4s.19-4.4-2.84-4.4-3.6 1.97-3.9 4.4-.2 4.4 2.82 4.4m1.16-9.32c3.37 0 3.7 2.08 3.35 4.92s-1.2 4.92-4.57 4.92-3.72-2.08-3.37-4.92 1.22-4.92 4.59-4.92"
                                  data-name="Path_144"
                                />
                                <path
                                  d="M51.67 11.93c-.21 1.7.68 2.12 2.28 2.12a7 7 0 0 0 3.48-.8l1.04-8.43h.6l-1.35 11.06c-.34 2.74-1.8 3.51-4.41 3.51a7 7 0 0 1-3.12-.56l.05-.58a7.5 7.5 0 0 0 3.15.62c2.6 0 3.48-1 3.72-2.97l.27-2.14a8 8 0 0 1-3.5.81c-2.25 0-3.06-.77-2.82-2.7l.86-7.05h.62Z"
                                  data-name="Path_145"
                                />
                                <path
                                  d="m70.6 13.25.88-7.18a5.7 5.7 0 0 0-3.21-.81c-2.88 0-3.67 2.22-3.94 4.4s-.02 4.4 2.85 4.4a6.7 6.7 0 0 0 3.42-.81m.44 1.23h-.25l-.2-.75a7 7 0 0 1-3.46.85c-3.2 0-3.72-2.14-3.4-4.92.35-2.78 1.41-4.92 4.61-4.92a6 6 0 0 1 3.26.85l.37-.76h.24Z"
                                  data-name="Path_146"
                                />
                                <path
                                  d="M78.5 14.57c-1.02 0-1.41-.46-1.3-1.4L78.82 0h.58l-1.62 13.13c-.1.73.08.98.77.98Z"
                                  data-name="Path_147"
                                />
                                <path
                                  d="M88.29 14.58h-.23q-3.24.01-2.93-2.59l.83-6.64h-1.83l.04-.32 1.84-.22.35-2.87.6-.08-.37 2.97h3.3l-.05.52h-3.3l-.85 6.8c-.17 1.5.99 1.97 2.43 1.97h.23Z"
                                  data-name="Path_148"
                                />
                                <path
                                  d="M94.57 11.93c-.2 1.7.68 2.12 2.28 2.12a7 7 0 0 0 3.49-.8l1.04-8.43h.6l-1.35 11.06c-.35 2.74-1.81 3.51-4.42 3.51a7 7 0 0 1-3.12-.56l.06-.58a7.5 7.5 0 0 0 3.14.62c2.6 0 3.49-1 3.72-2.97l.27-2.14a8 8 0 0 1-3.49.81c-2.25 0-3.06-.77-2.83-2.7l.86-7.05h.62Z"
                                  data-name="Path_149"
                                />
                                <path
                                  d="M117.99 7.24c3.05 0 3.67-1.48 3.9-3.34s-.04-3.34-3.08-3.34h-4.23l-.81 6.68Zm-5.1 7.24h-.62L114.04 0h4.55c3.6 0 4.22 1.43 3.91 3.9-.27 2.13-1.02 3.48-3.54 3.82l2.81 6.76h-.75l-2.68-6.7q-.34.02-.72.02h-3.93Z"
                                  data-name="Path_150"
                                />
                                <path
                                  d="M130.68 9.39c2.21 0 3-.75 3.16-2.06s-.44-2.07-2.66-2.07c-2.76 0-3.59 1.95-3.9 4.13Zm-3.47.54c-.22 2.18.13 4.13 2.89 4.13a10 10 0 0 0 3.12-.48l-.06.52a10 10 0 0 1-3.12.48c-3.2 0-3.74-2.04-3.4-4.92s1.41-4.92 4.61-4.92c2.64 0 3.36 1.1 3.16 2.59-.17 1.48-1.17 2.6-3.81 2.6Z"
                                  data-name="Path_151"
                                />
                              </g>
                              <path
                                fill="#313232"
                                d="m147.02 13.58 3.37-8.75h.66l-3.92 9.75h-.46l-1.66-9-3.85 9h-.46l-1.53-9.75h.66l1.21 8.75 3.72-8.75h.7Z"
                                data-name="Path_152"
                              />
                              <g data-name="Group 77">
                                <path
                                  fill="#313232"
                                  d="m161.71 13.25.88-7.18a5.7 5.7 0 0 0-3.22-.81c-2.87 0-3.66 2.22-3.93 4.4s-.02 4.4 2.85 4.4a6.7 6.7 0 0 0 3.42-.81m.44 1.23h-.25l-.2-.75a7.4 7.4 0 0 1-3.47.85c-3.2 0-3.72-2.14-3.39-4.92.35-2.78 1.4-4.92 4.6-4.92a6 6 0 0 1 3.27.85l.36-.76h.25Z"
                                  data-name="Path_153"
                                />
                                <path
                                  fill="#313232"
                                  d="M173.62 5.32a7 7 0 0 0-.9-.06 7 7 0 0 0-3.47.8l-1.02 8.42h-.62l1.17-9.65h.3l.17.76a8 8 0 0 1 3.54-.85 6 6 0 0 1 .9.06Z"
                                  data-name="Path_154"
                                />
                                <path
                                  fill="#313232"
                                  d="m184.43 13.25.89-7.18a5.7 5.7 0 0 0-3.22-.82c-2.88 0-3.67 2.22-3.93 4.4s-.02 4.4 2.85 4.4a6.7 6.7 0 0 0 3.41-.8m.94-7.7.7-5.54h.58l-1.78 14.46h-.24l-.2-.75a7 7 0 0 1-3.46.85c-3.2 0-3.72-2.15-3.4-4.93.35-2.78 1.42-4.92 4.6-4.92a6 6 0 0 1 3.2.81"
                                  data-name="Path_155"
                                />
                                <path
                                  fill="#313232"
                                  d="M196.36 11.9c.17-1.4-.21-1.9-2.43-2.16-2.5-.31-3.02-.9-2.83-2.41.2-1.49 1.17-2.59 3.81-2.59a9 9 0 0 1 2.62.39l-.05.52a9 9 0 0 0-2.64-.39c-2.22 0-3.01.75-3.16 2.07-.18 1.38.42 1.66 2.45 1.9 2.46.32 3.02.93 2.8 2.65-.16 1.4-1.15 2.7-4.1 2.7a9 9 0 0 1-2.64-.38l.08-.52a9 9 0 0 0 2.62.38c2.5 0 3.32-.98 3.47-2.16"
                                  data-name="Path_156"
                                />
                                <path
                                  fill="#313232"
                                  d="M209.24 7.82h3.99c3.2 0 3.95-1.99 4.14-3.63.21-1.66-.06-3.63-3.26-3.63h-3.98Zm8.75-3.63c-.27 2.18-1.43 4.17-4.93 4.17h-3.9l-.73 6.12h-.62L209.58 0h4.52c3.5 0 4.16 2.01 3.89 4.2"
                                  data-name="Path_157"
                                />
                                <path
                                  fill="#313232"
                                  d="M227.08 5.32a7 7 0 0 0-.91-.06 7 7 0 0 0-3.47.8l-1.03 8.42h-.61l1.17-9.65h.3l.17.76a8 8 0 0 1 3.54-.85 6 6 0 0 1 .89.06Z"
                                  data-name="Path_158"
                                />
                                <path
                                  fill="#313232"
                                  d="M234.47 14.06c3.02 0 3.62-1.97 3.91-4.4s.2-4.4-2.83-4.4-3.61 1.97-3.92 4.4c-.28 2.43-.19 4.4 2.84 4.4m1.15-9.32c3.38 0 3.7 2.08 3.36 4.92s-1.2 4.92-4.57 4.92-3.72-2.08-3.37-4.92 1.21-4.92 4.58-4.92"
                                  data-name="Path_159"
                                />
                                <path
                                  fill="#313232"
                                  d="m250.93 13.25.89-7.18a5.7 5.7 0 0 0-3.22-.81c-2.87 0-3.66 2.22-3.93 4.4s-.02 4.4 2.85 4.4a6.7 6.7 0 0 0 3.41-.81m.27 2.64c-.35 2.74-1.81 3.52-4.41 3.52a7 7 0 0 1-3.12-.56l.05-.58a7.5 7.5 0 0 0 3.14.62c2.6 0 3.51-1 3.74-2.98l.27-2.14a7.4 7.4 0 0 1-3.41.81c-3.2 0-3.72-2.14-3.4-4.92.36-2.78 1.42-4.92 4.61-4.92a6 6 0 0 1 3.26.85l.37-.76h.25Z"
                                  data-name="Path_160"
                                />
                                <path
                                  fill="#313232"
                                  d="M262.87 5.32a7 7 0 0 0-.91-.06 7 7 0 0 0-3.47.8l-1.02 8.42h-.62l1.18-9.65h.28l.18.76a8 8 0 0 1 3.54-.85 6 6 0 0 1 .9.06Z"
                                  data-name="Path_161"
                                />
                                <path
                                  fill="#313232"
                                  d="m273.7 13.25.88-7.18a5.7 5.7 0 0 0-3.22-.81c-2.87 0-3.66 2.22-3.93 4.4s-.02 4.4 2.85 4.4a6.7 6.7 0 0 0 3.41-.81m.44 1.23h-.25l-.19-.75a7.4 7.4 0 0 1-3.47.85c-3.2 0-3.72-2.14-3.4-4.92.35-2.78 1.42-4.92 4.61-4.92a6 6 0 0 1 3.26.85l.37-.76h.25Z"
                                  data-name="Path_162"
                                />
                                <path
                                  fill="#313232"
                                  d="M286.3 7.19c.2-1.66-.44-1.93-1.89-1.93a6 6 0 0 0-3.16.8l-1.02 8.43h-.61l1.17-9.65h.29l.17.75a7 7 0 0 1 3.24-.85c1.35 0 2.03.33 2.32 1.02a7 7 0 0 1 3.48-1.02c2.08 0 2.65.77 2.43 2.5l-.88 7.25h-.62l.89-7.3c.19-1.66-.45-1.93-1.9-1.93a6.3 6.3 0 0 0-3.3.94 5 5 0 0 1 0 1.04l-.88 7.24h-.61Z"
                                  data-name="Path_163"
                                />
                                <path
                                  fill="#313232"
                                  d="M303.88 7.19c.2-1.66-.44-1.93-1.89-1.93a6 6 0 0 0-3.16.8l-1.02 8.43h-.63l1.18-9.65h.29l.17.75a7 7 0 0 1 3.24-.85c1.35 0 2.02.33 2.31 1.02a7 7 0 0 1 3.5-1.02c2.07 0 2.63.77 2.42 2.5l-.89 7.25h-.61l.88-7.3c.2-1.66-.44-1.93-1.88-1.93a6.3 6.3 0 0 0-3.3.94 5 5 0 0 1 0 1.04l-.9 7.24h-.6Z"
                                  data-name="Path_164"
                                />
                                <path
                                  fill="#313232"
                                  d="M319.2 9.39c2.22 0 3.01-.75 3.17-2.06s-.45-2.07-2.66-2.07c-2.76 0-3.59 1.95-3.9 4.13Zm-3.46.54c-.22 2.18.13 4.13 2.89 4.13a10 10 0 0 0 3.12-.48l-.06.52a10 10 0 0 1-3.12.48c-3.2 0-3.74-2.04-3.4-4.92s1.42-4.92 4.61-4.92c2.65 0 3.36 1.1 3.17 2.59s-1.18 2.6-3.82 2.6Z"
                                  data-name="Path_165"
                                />
                                <path
                                  d="M265.66 29.13c9.45 0 18.91-.11 28.35.04 6.56.1 13.02 1.08 18.98 4.07 3.53 1.77 6.5 4.16 8.2 7.88a15.2 15.2 0 0 1 .3 11.61c-2.45 7.04-7.48 11.8-14.02 15.1a54 54 0 0 1-20.02 5.22 3 3 0 0 0-.78.08q-1.1.4-2.19.84a8 8 0 0 0 1.3 2.16 73 73 0 0 1 11.5 12.58c2.97 3.9 5.8 7.9 8.65 11.9a8 8 0 0 1 .7 1.67 11 11 0 0 1-1.72.28l-16.6-.05a55 55 0 0 1-5.94.03 4 4 0 0 1-2.36-1.65c-4.95-7.03-9.73-14.19-14.77-21.15a27 27 0 0 0-5.3-4.83 4.4 4.4 0 0 0-2.5-.67c-4.13-.07-8.25-.01-12.38-.05a2.66 2.66 0 0 0-2.86 2.1c-2.81 8.2-5.73 16.36-8.55 24.55a2.24 2.24 0 0 1-2.61 1.76c-6.89-.1-13.78-.02-20.67.03-1.45.02-1.83-.37-1.34-1.76 2.5-7.1 5.04-14.17 7.53-21.26a771 771 0 0 0 5.2-15.11c.49-1.48 1.3-1.81 2.78-1.8 14.15.12 28.3.23 42.44.17a98 98 0 0 0 12.48-.9c6.4-.86 12.32-2.85 16.49-8.26 3.51-4.56 1.9-9.9-3.48-12.07-3.46-1.4-7.05-1.5-10.63-1.52-16.4-.1-32.79-.08-49.18-.1-2.3 0-2.31-.02-1.56-2.12.86-2.4 1.74-4.82 2.5-7.26a1.9 1.9 0 0 1 2.14-1.55q14.96.04 29.92.02Z"
                                  data-name="Path_166"
                                />
                                <path
                                  d="M56.84 29.13c9.45 0 18.9-.11 28.34.04 6.56.1 13.01 1.08 18.98 4.07 3.53 1.77 6.5 4.16 8.2 7.88a15.2 15.2 0 0 1 .3 11.61c-2.45 7.04-7.48 11.8-14.02 15.1a54 54 0 0 1-20.02 5.22 3 3 0 0 0-.78.08q-1.1.4-2.19.84a8 8 0 0 0 1.3 2.16 73 73 0 0 1 11.5 12.58c2.98 3.9 5.8 7.9 8.66 11.9a8 8 0 0 1 .7 1.67 11 11 0 0 1-1.73.27l-16.6-.05a55 55 0 0 1-5.94.04 4 4 0 0 1-2.36-1.66c-4.95-7.03-9.73-14.18-14.78-21.15a27 27 0 0 0-5.3-4.82 4.4 4.4 0 0 0-2.5-.67c-4.12-.07-8.24-.02-12.37-.05a2.7 2.7 0 0 0-2.86 2.1c-2.81 8.2-5.73 16.36-8.55 24.55a2.24 2.24 0 0 1-2.61 1.75c-6.89-.1-13.78-.01-20.67.04-1.45.01-1.83-.37-1.34-1.76 2.5-7.1 5.04-14.17 7.53-21.26a799 799 0 0 0 5.2-15.12c.49-1.48 1.3-1.8 2.78-1.8 14.15.13 28.3.23 42.44.18a98 98 0 0 0 12.48-.91c6.4-.85 12.32-2.84 16.49-8.26 3.51-4.55 1.9-9.9-3.48-12.06-3.45-1.4-7.05-1.5-10.63-1.52-16.39-.11-32.78-.09-49.18-.1-2.3 0-2.31-.02-1.56-2.12.86-2.41 1.73-4.82 2.5-7.26a1.9 1.9 0 0 1 2.15-1.55q14.96.04 29.9.02Z"
                                  data-name="Path_167"
                                />
                              </g>
                            </g>
                          </svg>
                        </g>
                        <g
                          data-name="Group 138"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="5"
                        >
                          <circle
                            data-name="Ellipse 11"
                            cx="38.5"
                            cy="38.5"
                            r="38.5"
                            transform="translate(38 27.1)"
                          />
                          <path
                            data-name="Path_131"
                            d="M49.4 23.8H14.6V3.6a2 2 0 0 1 1.8-1.8h67.7A2 2 0 0 1 86 3.6v12.8"
                          />
                          <path data-name="Line_13" d="M26 11.1v11" />
                          <path data-name="Line_14" d="M40 11.1v11" />
                          <path
                            data-name="Path_132"
                            d="M31.1 45.8H7.3a2 2 0 0 1-1.8-2V25.6a2 2 0 0 1 1.8-1.8h7.3"
                          />
                          <path data-name="Line_15" d="M16 33.1v13" />
                          <path data-name="Line_16" d="M31 33.1v11" />
                          <path data-name="Path_133" d="M27.4 67.7H14.6v-22" />
                          <path data-name="Line_17" d="M26 55.1v11" />
                          <path
                            data-name="Path_134"
                            d="M32.9 89.7H3.6a2 2 0 0 1-1.8-2V69.4a2 2 0 0 1 1.8-1.8h11"
                          />
                          <path data-name="Line_18" d="M13 77.1v11" />
                          <path data-name="Line_19" d="M27 77.1v11" />
                        </g>
                      </g>
                    </svg>
                  </IconWrapper>
                  <h4>Visa Reload</h4>
                  <p className="spacer--bottom">Learn More</p>
                </a>
              </Panel2>
            </Col>
          </Row>
        </Grid>

        <BgPrimary>
          <Dashboard>
            <Row justifyContent="center">
              <Col xs={12}>
                <h2 className="h1 text--center ">Your Dashboard</h2>
              </Col>
              <Col xs={12} md={3}>
                <Link to="/my-points">
                  <IconWrapper>
                    <img src={Points} alt="" />
                  </IconWrapper>
                  <span>Your Points</span>
                </Link>
              </Col>
              <Col xs={12} md={3}>
                <Link to="/account">
                  <IconWrapper>
                    <img src={Account} alt="" />
                  </IconWrapper>
                  <span>Your Account</span>
                </Link>
              </Col>
              <Col xs={12} md={3}>
                <Link to="/wishlist">
                  <IconWrapper>
                    <img src={Wishlist} alt="" />
                  </IconWrapper>
                  <span>Your Wishlist</span>
                </Link>
              </Col>
            </Row>
          </Dashboard>
        </BgPrimary>

        <DiscoverRewards>
          <Grid>
            <Row className="spacer">
              <Col xs={12} md={6}>
                <h2 className="h1 text--primary">Discover Your Rewards</h2>
                <Link to="/shop" className="button">
                  Discover More
                </Link>
              </Col>
            </Row>
          </Grid>
        </DiscoverRewards>
      </PrivateComponent>
    </div>
  );
};

HomePage.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default withSettings(HomePage);
